<template>
  <div id="app">
    <nav class="navbar navbar-inverse navbar-fixed-top">
      <div class="container">
        <div class="navbar-header">
          <img src="./assets/logo.svg" class="mainlogo "/>
          <h1 class="site-name"><a class="navbar-brand" href="#">PoDP {{infoversion}}</a></h1>
          <ul class="nav navbar-nav">
            <li>
              <router-link to="/demande">Demande</router-link>
            </li>
            <li v-if="isItDevEnv">
              <router-link to="/test">Test</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <main>
      <div class="container">
          <router-view :key="$route.fullPath"></router-view>
      </div>
    </main>
  </div>
</template>

<script>
  import {BUILD_DATE, VERSION, DEV} from './components/config'
  export default {
    name: 'app',
    components: {},
    data () {
      return {
        isItDevEnv: DEV,
        infoversion: `ver:${VERSION} ${BUILD_DATE}`
      }
    }
  }
</script>

<style lang="scss">
  @import 'styles/imports';
  .site-name{
    display: inline;
  }
  main {
    margin: $navbar_height / 10;
    padding: $navbar_height $navbar_height / 10;
  }

  .mainlogo {
    position: relative;
    top: 2px;
    left: 2px;
    width: $navbar_height - 4;
    height: $navbar_height - 4;
    padding-right: $navbar_height / 5;
    float: left;
  }

  #demandelist {
    position: relative;
    top: 2px;
    background-color: white;
    width: 450px;
    font-size: smaller;
    // height: $navbar_height - 4;
    margin: 2px;
    // padding: 2px;
    display: inline-flex;
  }

  #listDemande {
    width: 100%;
  }

  @media (max-width: 600px) {
    #demandelist {
      width: auto;
    }
    #listDemande {
      width: auto;
    }
    .nav > li {
      display: inline;
    }

    .nav > li > a {
      display: inline;
    }

  }

  .g-signin-button {

    position: absolute;
    top: 7px;
    right: 3px;
    padding: 3px;
    display: inline;
    background: white;
    color: #444;
    border-radius: 5px;
    border: thin solid #888;
    box-shadow: 1px 1px 1px #31c8f6;
    white-space: nowrap;
    &:hover {
      cursor: pointer;
    }
  }

  .btn-google-sign {
    position: absolute;
    top: 2px;
    right: 2px;
    display: inline;
    background-color: black;
  }

  /*
   html {
    font-size: 100%;
  }

  body {
    margin: 0;
  }

  #app {

    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }


    header {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: $navbar_height;
      width: 100%;
      margin: 0;
      padding: 0 16px 0 0;
      background-color: $nav-bg-color;
      color: $nav-color;
      vertical-align: middle;
      z-index: 1000;

      }



      .center {
        position: absolute;
        left: 0;
        top: ($navbar_height / 2) - ($navbar_height / 4);
        width: 100%;
        padding-left: $navbar_height * 1.2;
        font-size: ($navbar_height / 2);
      }
      .router-link-exact-active{
        color: $nav-bg-color;
        background-color: $nav-color;
        text-decoration: none;
      }

      a {
        text-decoration: none;
        background-color: $nav-bg-color;
        color: $nav-color;
        padding-left: $navbar_height / 4;
        padding-right: $navbar_height / 4;
        &:hover {
          background-color: $nav-color;
          color: $nav-bg-color;
          text-decoration: none;
        }
      }

    }
  */
</style>



// WEBPACK FOOTER //
// src/App.vue